import C from "../constants";

const initialState = {
  token: "",
  user: {},
  waitResponse: false,
  error: false,
};

export default function (state, action) {
  switch (action.type) {
    case C.LOGIN:
    case C.REGISTER:
    case C.CONFIRM:
    case C.RESEND_CONFIRM:
    case C.CHANGE_PASSWORD:
    case C.FORGOT_PASSWORD:
    case C.SET_HIJACK:
    case C.GET_CURRENT_COMPANY:
    case C.PROCESS_SEND_NOTIFICATION:
      return {
        ...state,
        waitResponse: true,
        error: false,
        accessError: false,
        resend: false,
        isSendEmail: false,
        isSessionExpired: false,
      };
    case C.LOGIN_FAIL:
    case C.CONFIRM_FAIL:
    case C.RESEND_CONFIRM_FAIL:
    case C.CHANGE_PASSWORD_FAIL:
    case C.FORGOT_PASSWORD_FAIL:
    case C.HIDE_HINT_FAIL:
    case C.SET_HIJACK_FAIL:
    case C.PROCESS_SEND_NOTIFICATION_FAIL:
    case C.UPDATE_PASSWORD_FAIL:
    case C.CHANGE_EMAIL_FAIL:
    case C.GET_CURRENT_COMPANY_FAIL:
    case C.CANCEL_CHANGE_EMAIL_FAIL:
      const { status } = action.error;
      if (status === 400) {
        return {
          ...state,
          waitResponse: false,
          formErrors: action.error.formErrors,
          planId: action.error.planId,
          subscriptionsUsersId: action.error.subscriptionsUsersId,
        };
      } else if (status === 403) {
        return {
          ...state,
          waitResponse: false,
          accessError: action.error.message,
        };
      }
      return {
        ...state,
        waitResponse: false,
        error: action.error,
      };
    case C.REGISTER_FAIL:
      if (action.error.status === 400) {
        return {
          ...state,
          waitResponse: false,
          formErrors: action.error.details.errors,
        };
      }
      return {
        ...state,
        waitResponse: false,
        error: action.error,
      };
    case C.LOGIN_SUCCESS:
    case C.CONFIRM_SUCCESS:
    case C.SET_HIJACK_SUCCESS:
      const { token, user } = action.result;
      return {
        ...state,
        token: token || state.token,
        user: user || state.user,
        waitResponse: false,
        error: false,
      };
    case C.REGISTER_SUCCESS:
      return {
        ...state,
        registered: true,
        waitResponse: false,
        error: false,
      };
    case C.RESEND_CONFIRM_SUCCESS:
      return {
        ...state,
        resend: true,
      };
    case C.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isSendEmail: true,
      };
    case C.CHANGE_PASSWORD_SUCCESS:
    case C.UPDATE_PASSWORD_SUCCESS:
      const { last_activity } = action.result;
      return {
        ...state,
        user: {
          ...state.user,
          last_activity: last_activity,
        },
        formErrors: undefined,
      };
    case C.HIDE_HINT_SUCCESS:
    case C.PROCESS_SEND_NOTIFICATION_SUCCESS:
    case C.CHANGE_EMAIL_SUCCESS:
    case C.CANCEL_CHANGE_EMAIL_SUCCESS:
      const { meta_info } = action.result;
      return {
        ...state,
        user: {
          ...state.user,
          meta_info: meta_info,
        },
      };
    case C.PROFILE_UPDATE_SUCCESS:
      const { data } = action.result;
      const personData = data.person;
      delete data.person;
      return {
        ...state,
        user: {
          ...state.user,
          ...data,
          person: {
            ...state.user.person,
            ...personData,
          },
        },
      };
    case C.SESSION_EXPIRED:
      return {
        ...initialState,
        isSessionExpired: true,
        user: {},
      };
    case C.NOT_AUTHORIZED:
      return {
        ...initialState,
        user: {},
      };
    case C.UPDATE_ACCOUNT_SUCCESS:
      if (state.user.role_id !== C.ADMIN_ROLE) {
        return {
          ...state,
          user: {
            ...state.user,
          },
        };
      }
      return state;
    case C.GET_CURRENT_COMPANY_SUCCESS:
      return {
        ...state,
        company: {
          ...action.result,
        },
      };
    default:
      return state || initialState;
  }
}
